import { Trial } from './../models/trial';
import { Injectable } from '@angular/core';
import { TrialStage } from '../models/trialStageEnum';
import { ExperimentService } from './experiment.service';
import { EmotionOption } from '../models/emotionOptionEnum';

@Injectable({
  providedIn: 'root',
})
export class TrialService {
  currentTrialIsTraining = true;

  currentStage = TrialStage.Classification;

  constructor() {}

  public prepareForStart() {
    console.log('Training');
    this.currentTrialIsTraining = true;
    this.currentStage = TrialStage.Classification;
  }

  public prepareForNextTrial() {
    this.currentTrialIsTraining = false;
    this.currentStage = TrialStage.Classification;
  }

  public goToIntensityRating() {
    this.currentStage = TrialStage.IntensityRating;
  }
}
